var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.teamStage === '8th Finals')?_c('span',[_vm._v("Round of 16")]):(_vm.teamStage === '3rd Place Final')?_c('span',[_vm._v("Third Place Play-Off")]):(_vm.teamStage === '八分之一决赛')?_c('span',[_vm._v("16强")]):(_vm.teamStage === '四分之一决赛')?_c('span',[_vm._v("8强")]):_c('span',[_vm._v(_vm._s(_vm.teamStage))])
}
var staticRenderFns = []

export { render, staticRenderFns }